<style lang="scss" scoped>
.page-vehicle-insurance {
    .short-input {
        width: 120px;
    }
    .short-input.short-input2 {
        width: 136px;
    }
    .short-input.short-input3 {
        width: 166px;
    }
}
</style>

<template>
    <div class="page-vehicle-insurance">
        <div class="toolbars mrgb5">
            <div class="buttons mrgb5">
                <div class="fl mrgb5">
                    <el-upload class="dib mrgr5" :action="uploadUrlVehicle" :headers="uploadHeaders" 
                        :on-success="importData" :on-error="importData" :show-file-list="false"
                        :before-upload="beforeAvatarUpload"
                        v-if="isAnalysisVehicleDataImport">
                        <el-button type="warning" size="medium"><i class="fa fa-sign-in"></i> 导入车辆数据</el-button>
                    </el-upload>
                    <el-upload class="dib mrgr5" :action="uploadUrlInsurance" :headers="uploadHeaders" 
                        :on-success="importData" :on-error="importData" :show-file-list="false"
                        :before-upload="beforeAvatarUpload"
                        v-if="isAnalysisVehicleDataImport">
                        <el-button type="danger" size="medium"><i class="fa fa-sign-in"></i> 导入保险数据</el-button>
                    </el-upload>
                </div>
                <div class="fr">
                    <el-checkbox class="mrgr5 mrgb5" v-model="listQuery.isFilterArea" label="仅看当前服务区" border size="medium"
                        @change="changeIsFilterArea"></el-checkbox>
                    <el-select class="c-el-input short-input mrgr5 mrgb5" placeholder="平台筛选" size="medium" filterable
                    clearable v-model="listQuery.platform" @change="changePlatform" v-show="!listQuery.isFilterArea">
                        <el-option v-for="item in allPlatforms" :key="'platform-' + item" :label="item" :value="item"></el-option>
                    </el-select>
                    <el-select class="c-el-input short-input mrgr5 mrgb5" placeholder="服务区筛选" size="medium" filterable
                        clearable v-model="listQuery.area" @change="changeArea" v-show="!listQuery.isFilterArea && listQuery.platform">
                        <el-option v-for="item in allServiceAreas" :key="'area-' + item.id" :label="item.name" :value="item.name"></el-option>
                    </el-select>
                    <el-select class="c-el-input short-input short-input3 mrgr5 mrgb5" placeholder="保险状态筛选" size="medium" multiple collapse-tags
                        clearable v-model="listQuery.insuranceStatuses" @change="_search()">
                        <el-option label="正常" :value="0"></el-option>
                        <el-option label="无保险" :value="1"></el-option>
                        <el-option label="已过期" :value="2"></el-option>
                        <el-option label="即将到期" :value="3"></el-option>
                    </el-select>
                    <el-select class="c-el-input short-input short-input2 mrgr5 mrgb5" placeholder="近期订单筛选" size="medium" filterable
                        clearable v-model="listQuery.hasRecentOrder" @change="_search()">
                        <el-option label="近N天有订单" :value="true"></el-option>
                        <el-option label="近N天无订单" :value="false"></el-option>
                    </el-select>
                    <!-- <el-select class="c-el-input short-input mrgr5 mrgb5" placeholder="保单查询" size="medium" filterable
                        clearable v-model="listQuery.hasInsurance" @change="_search()">
                        <el-option label="有保单" :value="true"></el-option>
                        <el-option label="无保单" :value="false"></el-option>
                    </el-select> -->
                    <el-select class="c-el-input short-input mrgr5 mrgb5" placeholder="车架号查询" size="medium" filterable
                        clearable v-model="listQuery.hasChassisNo" @change="_search()">
                        <el-option label="有车架号" :value="true"></el-option>
                        <el-option label="无车架号" :value="false"></el-option>
                    </el-select>

                    <el-input class="c-el-input mrgr5 mrgb5" placeholder="输入搜索内容" clearable v-model="listQuery.keywords"
                        size="medium"></el-input>
                    <el-button class="mrgr5 mrgb5" type="primary" size="medium" @click="_search()"><i class="fa fa-search"></i> 查询</el-button>
                    <el-button class="mrgb5" type="warning" size="medium" @click="openExportDialog()">
                        <i class="fa fa-sign-out"></i> 导出
                    </el-button>
                </div>
                <div class="clearb"></div>
            </div>
        </div>
        <div>
            <el-table :data="tableData" style="width: 100%" border size="small">
                <el-table-column label="最后同步时间" prop="lastSyncTimeDesc" width="100"></el-table-column>
                <el-table-column label="最后订单时间" prop="lastOrderTimeDesc" width="100"></el-table-column>
                <el-table-column label="最后在线时间" prop="lastOnlineTimeDesc" width="100"></el-table-column>
                <el-table-column label="平台" prop="platformDesc"></el-table-column>
                <el-table-column label="服务区" prop="area"></el-table-column>
                <el-table-column label="保险区域" prop="insuranceArea"></el-table-column>
                <el-table-column label="区域检查结果">
                    <template slot-scope="scope">
                        <el-tag size="medium" :type="getAreaCheckTagType(scope.row.platform, scope.row.area, scope.row.insuranceArea)">
                            {{ checkAreaMatch(scope.row.platform, scope.row.area, scope.row.insuranceArea) }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="车辆类型" prop="model" width="80"></el-table-column>
                <el-table-column label="车辆号" prop="vehicleNo"></el-table-column>
                <el-table-column label="中控号" prop="controlNo" min-width="100"></el-table-column>
                <el-table-column label="车架号" prop="chassisNo" min-width="100"></el-table-column>
                <el-table-column label="保险单号" prop="insurancePolicyNumber"></el-table-column>
                <el-table-column label="保险状态" prop="insuranceStatusDesc" width="100">
                    <template slot-scope="scope">
                        <el-tag size="medium" type="success" v-if="scope.row.insuranceStatus === 1">{{ scope.row.insuranceStatusDesc }}</el-tag>
                        <el-tag size="medium" type="warning" v-if="scope.row.insuranceStatus === 2">{{ scope.row.insuranceStatusDesc }}</el-tag>
                        <el-tag size="medium" type="danger" v-if="scope.row.insuranceStatus === 0 || scope.row.insuranceStatus === 3">{{ scope.row.insuranceStatusDesc }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="被保人" prop="insuredName"></el-table-column>
                <el-table-column label="保险公司" prop="insuranceCompany"></el-table-column>
                <el-table-column label="保险开始时间" prop="insuranceStartDate"></el-table-column>
                <el-table-column label="保险截止时间" prop="insuranceEndDate"></el-table-column>
                <el-table-column label="扣车点">
                    <template slot-scope="scope">
                        <span class="col_danger" v-if="scope.row.isDetained">{{ scope.row.detainedPointName }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="handleCopy(scope.row)">复制</el-button>
                    </template>
                </el-table-column>
                <!-- <el-table-column label="中控序列号" prop="controlSN"></el-table-column>
                <el-table-column label="电机号" prop="motorNo"></el-table-column> -->
            </el-table>

            <div class="pagination-container" v-if="isPagination">
                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" 
                    :current-page="listQuery.page" :page-sizes="appPageSizes" :page-size="listQuery.size" 
                    layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </div>
        <vehicle-insurance-export-dialog ref="vehicleInsuranceExportDialog" :query="listQuery" :all-platforms="allPlatforms"
            :all-service-areas="allServiceAreas" :service-area-city-data="serviceAreaCityData"
            :max-export-counts="maxExportCount"></vehicle-insurance-export-dialog>
    </div>
</template>

<script>
import permission from "@/mixins/permission"
import configMixins from "@/mixins/config"
import * as funReport from "@/api/report"
import * as funAll from "@/api/all"
import moment from "moment"
import VehicleInsuranceExportDialog from "./components/VehicleInsuranceExportDialog"

// 区域检查结果状态定义
const AREA_CHECK_RESULTS = ["匹配失败", "一致", "不一致"]
export default {
    name: "pageAnalysisVehicle",
    mixins: [permission, configMixins],
    components: { VehicleInsuranceExportDialog },
    data() {
        return {
            uploadUrlVehicle: window.$common.appBaseApi() + "/api/app/vehicle/import-base",
            uploadUrlInsurance: window.$common.appBaseApi() + "/api/app/vehicle/import-insurance",
            uploadHeaders: window.$common.appHeaders(),
            tableData: [],
            total: null,
            listQuery: {
                isInsuranceExpiringSoon: null,
                insuranceStatuses: [],
                hasRecentOrder: null,
                hasInsurance: null,
                hasChassisNo: null,
                isFilterArea: false, // 是否筛选服务区
                platform: "",
                area: "",
                keywords: "",
                page: 1,
                size: window.$common.appPageSize
            },
            isPagination: false,
            // 所有的平台
            allPlatforms: [],
            // 所有的服务区
            allServiceAreas: [],
            // 服务区城市数据
            serviceAreaCityData: []
        }
    },
    watch: {
        "$store.getters.serviceArea"(v) {
            this.mxIsSameActiveTabWithRoute(() => {
                // 服务区改变时，查询所有的车辆
                if (this.listQuery.isFilterArea) {
                    this._search()
                }
            })
        }
    },
    mounted() {
        this.getDataList()
        this.queryAllPlatforms()
        this.loadServiceAreaCityData()
    },
    methods: {
        // 加载服务区城市数据
        async loadServiceAreaCityData() {
            try {
                const response = await funAll.SearchServiceAreas({
                    platform: "",
                    isActive: null,
                    city: "",
                    cityCode: ""
                })
                this.serviceAreaCityData = response || []
            } catch (error) {
                console.error('获取服务区城市数据失败:', error)
                this.serviceAreaCityData = []
            }
        },
        // 检查区域匹配结果
        // 返回值: "匹配失败", "一致", "不一致"
        checkAreaMatch(platform, area, insuranceArea) {
            // 如果保险区域为空，返回匹配失败
            if (!insuranceArea) {
                return AREA_CHECK_RESULTS[0]
            }
            // 如果保险区域包含"中华人民共和国"，返回一致
            if (insuranceArea.includes("中华人民共和国")) {
                return AREA_CHECK_RESULTS[1]
            }
            // 如果没有服务区城市数据，返回匹配失败
            if (!this.serviceAreaCityData || this.serviceAreaCityData.length === 0) {
                return AREA_CHECK_RESULTS[0]
            }
            // 根据平台和服务区查找对应的服务区城市配置
            const matchedConfig = this.serviceAreaCityData.find(item => item.platform === platform && item.name === area)
            // 如果没有找到对应的配置，或city为空，返回匹配失败
            if (!matchedConfig || !matchedConfig.city) {
                return AREA_CHECK_RESULTS[0]
            }
            // 保险区域包含在city内，返回一致
            if (matchedConfig.city.includes(insuranceArea)) {
                return AREA_CHECK_RESULTS[1]
            }
            // 不相同则显示不一致
            return AREA_CHECK_RESULTS[2]
        },
        // 获取区域检查结果的标签类型
        getAreaCheckTagType(platform, area, insuranceArea) {
            const result = this.checkAreaMatch(platform, area, insuranceArea)
            if (result === AREA_CHECK_RESULTS[0]) {
                return "info" // 匹配失败 - 灰色
            } else if (result === AREA_CHECK_RESULTS[1]) {
                return "success" // 一致 - 绿色
            } else {
                return "danger" // 不一致 - 红色
            }
        },
        // 获取所有的平台
        async queryAllPlatforms() {
            await funAll.AllPlatforms().then(res => {
                this.allPlatforms = res || []
            })
        },
        // 获取所有服务区
        async queryAllServiceAreas() {
            await funAll.AllServiceAreas({ platform: this.listQuery.platform || "", isActive: true }).then(res => {
                this.allServiceAreas = res || []
                this.allServiceAreas.sort((a, b) => {
                    if (a.enableSpider && !b.enableSpider) {
                        return -1
                    } else if (!a.enableSpider && b.enableSpider) {
                        return 1
                    } else {
                        return 0
                    }
                })
            })
        },
        changeIsFilterArea() {
            this.listQuery.platform = ""
            this.listQuery.area = ""
            this._search()
        },
        // 平台改变时，查询所有的服务区
        changePlatform(val) {
            this.listQuery.platform = ""
            this.listQuery.area = ""
            if (val) {
                this.listQuery.isFilterArea = false
                this.listQuery.platform = val
                this.queryAllServiceAreas()
            }
            this._search()
        },
        // 服务区改变时
        changeArea() {
            this._search()
        },
        handleSizeChange(val) {
            window.$common.fullLoading()
            this.listQuery.size = val
            this.getDataList()
        },
        handleCurrentChange(val) {
            window.$common.fullLoading()
            this.listQuery.page = val
            this.getDataList()
        },
        getDataList() {
            window.$common.fullLoading()
            let params = JSON.parse(JSON.stringify(this.listQuery))
            if (!params.isInsuranceExpiringSoon) {
                delete params.isInsuranceExpiringSoon
            }
            if (!params.insuranceStatuses || params.insuranceStatuses.length === 0) {
                delete params.insuranceStatuses
            }
            if (params.hasRecentOrder === null || params.hasRecentOrder === undefined || params.hasRecentOrder === "") {
                delete params.hasRecentOrder
            }
            if (params.isFilterArea) {
                params.platform = this.$store.getters.servicePlatform || ""
                params.area = this.$store.getters.serviceArea || ""
            }
            funReport.GetVehicles(params).then(response => {
                window.$common.closeFullLoading()
                this.total = response.totalCount
                this.isPagination = response.totalCount > 0 || false
                if (response && response.items && response.items.length > 0) {
                    this.tableData = response.items.map(x => {
                        x.platformDesc = x.platform // || this.$store.getters.servicePlatform || ""
                        x.insuranceStartDate = moment(x.insuranceStartDate).isValid() ? moment(x.insuranceStartDate).format("YYYY-MM-DD") : ""
                        x.insuranceEndDate = moment(x.insuranceEndDate).isValid() ? moment(x.insuranceEndDate).format("YYYY-MM-DD") : ""
                        x.lastSyncTimeDesc = moment(x.lastSyncTime).isValid() ? moment(x.lastSyncTime).format("YYYY-MM-DD HH:mm:ss") : ""
                        x.lastOrderTimeDesc = moment(x.lastOrderTime).isValid() ? moment(x.lastOrderTime).format("YYYY-MM-DD HH:mm:ss") : ""
                        x.lastOnlineTimeDesc = moment(x.lastOnlineTime).isValid() ? moment(x.lastOnlineTime).format("YYYY-MM-DD HH:mm:ss") : ""
                        x.isDetainedDesc = x.isDetained ? "是" : ""
                        return x
                    })
                } else {
                    this.tableData = []
                }
            })
        },
        beforeAvatarUpload() {
            window.$common.fullLoading()
        },
        // 导入
        importData(res) {
            window.$common.closeFullLoading()
            this.alert(res).then(() => {
                this._search()
            })
        },
        _search() {
            this.listQuery.page = 1
            this.getDataList()
        },
        openExportDialog() {
            this.$refs.vehicleInsuranceExportDialog.open()
        },
        // 复制单条车辆保险信息（与保险预警界面复制格式一致，保险状态字段名不同）
        handleCopy(row) {
            let fields = [
                { label: "最后在线时间", value: row.lastOnlineTimeDesc || "--" },
                { label: "最后订单时间", value: row.lastOrderTimeDesc || "--" },
                { label: "平台", value: row.platform || "--" },
                { label: "服务区", value: row.area || "--" },
                { label: "车辆号", value: row.vehicleNo || "--" },
                { label: "设备号", value: row.controlNo || "--" },
                { label: "车架号", value: row.chassisNo || "--" },
                { label: "保险单号", value: row.insurancePolicyNumber || "--" },
                { label: "保险状态", value: row.insuranceStatusDesc || "--" },
                { label: "保险区域", value: row.insuranceArea || "--" },
                { label: "被保人", value: row.insuredName || "--" },
                { label: "保险公司", value: row.insuranceCompany || "--" },
                { label: "保险开始日期", value: row.insuranceStartDate || "--" },
                { label: "保险结束日期", value: row.insuranceEndDate || "--" },
                { label: "扣车状态", value: row.isDetained ? "已扣车" : "--" },
                { label: "扣车点位", value: row.detainedPointName || "--" }
            ]
            let txt = fields.map(x => `${x.label}：${x.value}`).join("，")
            try {
                window.navigator.clipboard.writeText(txt).then(() => {
                    this.successMsg("复制成功!")
                })
            } catch (ex) {
                this.alert(txt, "手动复制", {
                    customClass: "wordbreakba"
                })
            }
        }
    }
}
</script>
